import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { DataService } from '../../../core/service/base/data.service';
import { LogRecord } from '../../../common/model/log-record';
import { finalize, map, Observable } from 'rxjs';
import { PagedResult } from '../../../core/model/paged-result';

@Injectable()
export abstract class LogBaseService extends DataService<LogRecord> {
  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService,
    url: string
  ) {
    super(client, config, messageService, LogRecord, progressBar, `${url}/log`);
  }

  getPagedList(contactId: string, page: number, pageSize: number): Observable<PagedResult<LogRecord>> {
    this.progressBar.start();
    return this.client
      .post<PagedResult<LogRecord>>(`${this.endpoint}/page`, {
        page: page,
        pageSize: pageSize,
        filter: { entityId: contactId },
      })
      .pipe(
        map(response => {
          let result = Object.assign(new PagedResult(), response);
          result.items = response.items.map(i => new LogRecord(i));
          return result;
        }),
        finalize(() => this.progressBar.stop())
      );
  }
}
